import React, { useState, useEffect } from "react";

import { toast } from "react-toastify";
import { privateAxiosIntance, publicAxiosInstance } from "../../Config/axios";

const AdSenseForm = () => {
  const [adds_key, setAddsKey] = useState("");

  const [analytics_key, setAnalyticsKey] = useState("");
  const [apiKey, setApiKey] = useState("");
  const [loading, setLoading] = useState(false);
  const [response, setResponse] = useState(null);
  const [error, setError] = useState("");
  const [isUpdate, setIsUpdate] = useState(false);

  const [gtm_key, setGtmKey] = useState("");

  useEffect(() => {
    fetchAdsenseData();
  }, []);

  const fetchAdsenseData = async () => {
    setLoading(true);
    try {
      const result = await privateAxiosIntance.get("blog/google-adsense-api/");

      if (result?.data?.response_code === 200) {
        setApiKey(result?.data?.data?.adsense_key);
        setAddsKey(result?.data?.data?.adds_key);
        setAnalyticsKey(result?.data?.data?.analytics_key);
        setGtmKey(result?.data?.data?.gtm_id);

        setIsUpdate(true);
      } else {
        setIsUpdate(false);
      }
    } catch (err) {
      setError("Failed to fetch AdSense data.");
    } finally {
      setLoading(false);
    }
  };

  const handleApiKeyChange = (e) => {
    setApiKey(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    setResponse(null);

    try {
      const apiUrl = isUpdate
        ? `blog/google-adsense-api/`
        : "blog/google-adsense-api/";

      const method = isUpdate ? "post" : "post";

      const result = await privateAxiosIntance[method](apiUrl, {
        adsense_key: apiKey,
        adds_key: adds_key,
        analytics_key: analytics_key,
        gtm_id: gtm_key,
      });

      setResponse(result.data);
      toast.success(result?.data?.message);

      fetchAdsenseData();
    } catch (err) {
      setError("An error occurred while submitting the AdSense data.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[90vh] w-full flex items-center justify-center bg-gray-200">
      <div className="max-w-2xl mx-auto p-6 bg-white rounded-lg shadow-lg w-full">
        <h1 className="text-2xl font-bold text-center mb-6">
          {isUpdate ? "Update" : "Add"} Your API Key to Google
        </h1>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="flex flex-col">
            <label htmlFor="apiKey" className="text-lg font-medium mb-2">
              AdSense API Key
            </label>
            <input
              type="text"
              id="apiKey"
              name="apiKey"
              value={apiKey}
              onChange={(e) => setApiKey(e.target.value)}
              placeholder="Enter your API Key"
              className="p-3 border border-gray-300 rounded-md text-lg"
              required
            />
          </div>

          <div className="flex flex-col">
            <label htmlFor="apiKey" className="text-lg font-medium mb-2">
              Analytics API Key
            </label>
            <input
              type="text"
              id="apiKey"
              name="apiKey"
              value={analytics_key}
              onChange={(e) => setAnalyticsKey(e.target.value)}
              placeholder="Enter your API Key"
              className="p-3 border border-gray-300 rounded-md text-lg"
              required
            />
          </div>

          <div className="flex flex-col">
            <label htmlFor="apiKey" className="text-lg font-medium mb-2">
              Adwords API Key
            </label>
            <input
              type="text"
              id="apiKey"
              name="apiKey"
              value={adds_key}
              onChange={(e) => setAddsKey(e.target.value)}
              placeholder="Enter your API Key"
              className="p-3 border border-gray-300 rounded-md text-lg"
              required
            />
          </div>

          <div className="flex flex-col">
            <label htmlFor="apiKey" className="text-lg font-medium mb-2">
              GTM Key
            </label>
            <input
              type="text"
              id="gtm_key"
              name="gtm_key"
              value={gtm_key}
              onChange={(e) => setGtmKey(e.target.value)}
              placeholder="Enter your GTM Key"
              className="p-3 border border-gray-300 rounded-md text-lg"
            />
          </div>

          <button
            type="submit"
            className={`w-full py-3 text-white font-semibold rounded-md transition-all duration-300 ${
              loading
                ? "bg-gray-400 cursor-not-allowed"
                : "bg-blue-500 hover:bg-blue-600"
            }`}
            disabled={loading}
          >
            {loading ? "Loading..." : isUpdate ? "Update" : "Submit"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdSenseForm;
